// React
import { memo } from 'react'

// Interfaces
import { IPreviewImagesLabelProps } from './interfaces'

// Components
import { PreviewActionButtons, Progress } from 'components/base/BaseUploader/BaseUploader/components'

const PreviewImagesLabel = memo(({ files, onRetry, onAbort, onChange }: IPreviewImagesLabelProps): JSX.Element => {
  return (
    files.length !== 0 ? (
      <div className="flex flex-col w-full">
        {files.map((file, index) => (
          <div className="flex flex-col mb-4" key={index}>
            {/* Action Buttons */}
            <PreviewActionButtons withLabel file={file} onRetry={onRetry} onAbort={onAbort} onChange={onChange} />

            {/* Progress */}
            <Progress file={file} />

            {/* Divider */}
            <div className="mt-4">
              <hr />
            </div>
          </div>
        ))}
      </div>
    ) : (
      <></>
    )
  ) as JSX.Element
})

export { PreviewImagesLabel }
